import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { log } from 'src/app/utils/logging';
import type { AppState } from 'src/types/appState';

export const ErrorTracker = () => {
  const currentPage = useSelector(
    (appState: AppState) => appState.tealium.page,
  );

  useEffect(() => {
    log.error(
      'PageViewTracker | ErrorTracker | Failed to load page view tracker',
      {
        currentPage,
      },
    );
  }, [currentPage]);

  return <></>;
};
